import { Box, Grid } from '@mui/material'
import {
  CopyButton,
  LabeledItem,
  StyledTextOrTranslation
} from '../../../../components'

interface VirtualBarCodeProps {
  virtualBarCode: string
}

export const VirtualBarCode = ({ virtualBarCode }: VirtualBarCodeProps) => {
  return (
    <LabeledItem labelTranslationId="pages.membershipFeesPage.referenceNumbers.virtualBarcode">
      <Grid container spacing={1}>
        <Grid item md="auto" xs={true}>
          <StyledTextOrTranslation
            text={virtualBarCode}
            typographyProps={{
              id: 'virtual-bar-code',
              variant: 'body2',
              sx: {
                wordBreak: 'break-all'
              }
            }}
          />
        </Grid>
        <Grid item xs="auto">
          <Box mt={-1}>
            <CopyButton
              content={virtualBarCode}
              translationId="pages.membershipFeesPage.calculateMembershipFeePage.copy"
            />
          </Box>
        </Grid>
      </Grid>
    </LabeledItem>
  )
}
